import { useEffect, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'

import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { logger } from '@user/utils/logger'
import { getEmployeeList } from '..'

export const useGetEmployeeListOnMount = (
  includeInactive?: boolean,
  enabled = true,
) => {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    if (!enabled) {
      setStatus('success')
      return
    }
    setStatus('pending')

    const execute = async () => {
      try {
        const result = await dispatch(getEmployeeList(includeInactive))

        if (mounted) {
          if (getEmployeeList.fulfilled.match(result)) {
            unwrapResult(result)
            setStatus('success')
          } else {
            // rejected
            if (result.payload) {
              logger.log(result.payload)
            } else {
              // unmanaged
              if (result.error.message) {
                logger.log(result.error)
              }
            }
            setStatus('fail')
          }
        }
      } catch (error) {
        logger.log(error)
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, enabled])

  return status
}
